import React, { useEffect, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Button,
  Form,
  Label,
  FormFeedback,
  Input,
} from "reactstrap"
import ReactQuill from "react-quill-new"
import "react-quill-new/dist/quill.snow.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import leftArrow from "../../assets/images/icons/left-arrow.svg"
import LoaderComponent from "components/loader"
import Spinners from "components/Common/Spinner"
import * as Yup from "yup"
import { useFormik } from "formik"
import toast from "react-hot-toast"
import { useEditFaqMutation, useLazyGetFaqQuery } from "store/api/faqs/faq"
import Breadcrumb from "components/Common/Breadcrumb"

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  // ["blockquote", "code-block"],
  ["link", "image"],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  // [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["clean"],
]

const FaqEdit = ({ user_type }) => {
  const { id } = useParams()
  const [getResult, { isFetching }] = useLazyGetFaqQuery()
  const [updateFaq, { isFetching: isUpdating }] = useEditFaqMutation()
  const navigate = useNavigate()

  document.title = "FAQ Details | Prachay"

  const getFaqData = async () => {
    try {
      const { success, data } = await getResult({ id }).unwrap()
      if (success) {
        validation.setFieldValue("question", data.question)
        validation.setFieldValue("answer", data.answer)
        validation.setFieldValue("status", data.status)
      }
    } catch (error) {}
  }

  const editFaq = async (values) => {
    try {
      const { success, message } = await updateFaq({
        id,
        ...values,
        user_type,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "FaqSuccess" })
        navigate(user_type === "INVESTOR" ? "/resources/faqs" : "/wp-faqs")
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  useEffect(() => {
    if (id) {
      getFaqData()
    }
  }, [id])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { question: "", status: "", answer: "" },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await editFaq(values)
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Update FAQ"} />
          <Row>
            <Col xl={12}>
              <Card>
                {isFetching ? (
                  <LoaderComponent />
                ) : (
                  <CardBody>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <Row className="mb-2">
                        <Col sm={6} className="mb-2">
                          <Label className="form-label">
                            Question<span className="error">*</span>
                          </Label>
                          <Input
                            name="question"
                            className="form-control"
                            placeholder={"Enter Question"}
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.question}
                            invalid={
                              validation.touched.question &&
                              validation.errors.question
                            }
                          />
                          {validation.touched.question &&
                          validation.errors.question ? (
                            <FormFeedback type="invalid">
                              {validation.errors.question}
                            </FormFeedback>
                          ) : null}
                        </Col>

                        <Col xl={6} className="mb-2">
                          <Label className="form-label">
                            Status<span className="error">*</span>
                          </Label>
                          <select
                            name="status"
                            className="form-select pageSize mb-2"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.status}
                          >
                            <option value={""}>Select Status</option>
                            {[
                              { label: "ACTIVE", value: "ACTIVE" },
                              { label: "DISABLE", value: "DISABLE" },
                            ].map((item, index) => (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                          {validation.touched.status &&
                          validation.errors.status ? (
                            <FormFeedback type="invalid">
                              {validation.errors.status}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col sm={12}>
                          <ReactQuill
                            theme="snow"
                            value={validation.values.answer}
                            onChange={(e) =>
                              validation.setFieldValue("answer", e)
                            }
                            placeholder="Enter Answer..."
                            modules={{
                              toolbar: toolbarOptions,
                            }}
                          />{" "}
                          {validation.touched.answer &&
                          validation.errors.answer ? (
                            <FormFeedback type="invalid">
                              {validation.errors.answer}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>

                      <Row className="justify-content-end mt-4">
                        <Col sm={12}>
                          <div className="d-flex justify-content-end align-items-center gap-3">
                            {/* <Link to={"/icd"}>
                            <button
                              // type="submit"
                              className="btn btn-cancel w-md"
                            >
                              Cancel
                            </button>
                          </Link> */}
                            <Button
                              type="submit"
                              className="btn btn-primary w-md"
                              disabled={isUpdating}
                            >
                              {isUpdating ? <Spinners /> : "Update Faq"}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default FaqEdit
